import React, { useState, useEffect } from 'react';

function SafetyGearQuiz({ questions, xpReward, coinReward, timeLimit, onComplete }) {
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [feedback, setFeedback] = useState(null); // 'correct' | 'wrong'
  const [timer, setTimer] = useState(timeLimit);
  const [score, setScore] = useState(0);
  const [coins, setCoins] = useState(0);
  const [showResult, setShowResult] = useState(false);

  useEffect(() => {
    if (showResult) return;
    if (timer === 0) {
      handleAnswer(null);
      return;
    }
    const t = setTimeout(() => setTimer(timer - 1), 1000);
    return () => clearTimeout(t);
  }, [timer, showResult]);

  const handleAnswer = (option) => {
    if (selected !== null) return;
    setSelected(option);
    const correct = questions[current].correctAnswer;
    if (option === correct) {
      setFeedback('correct');
      setScore(s => s + 1);
      setCoins(c => c + coinReward);
    } else {
      setFeedback('wrong');
    }
    setTimeout(() => {
      setFeedback(null);
      setSelected(null);
      setTimer(timeLimit);
      if (current + 1 < questions.length) {
        setCurrent(c => c + 1);
      } else {
        setShowResult(true);
        setTimeout(() => onComplete({ correct: score + (option === correct ? 1 : 0), xp: xpReward * (score + (option === correct ? 1 : 0)), coins: coinReward * (score + (option === correct ? 1 : 0)) }), 1200);
      }
    }, 900);
  };

  if (showResult) {
    return (
      <div style={{ textAlign: 'center', padding: 24 }}>
        <h3 style={{ color: '#22c55e', fontWeight: 800, fontSize: 24, marginBottom: 12 }}>Quiz Complete!</h3>
        <div style={{ fontSize: 18, marginBottom: 10 }}>You earned:</div>
        <div style={{ fontWeight: 700, fontSize: 22, color: '#22c55e' }}>{xpReward * score} XP</div>
        <div style={{ fontWeight: 700, fontSize: 22, color: '#fbbf24' }}>{coinReward * score} Coins</div>
        <div style={{ marginTop: 18, color: '#555' }}>Correct Answers: {score} / {questions.length}</div>
        <button className="gogig-card-btn" style={{ marginTop: 24 }} onClick={() => onComplete({ correct: score, xp: xpReward * score, coins: coinReward * score })}>Continue</button>
      </div>
    );
  }

  const q = questions[current];
  const percent = ((timeLimit - timer) / timeLimit) * 100;

  return (
    <div style={{ padding: 12, minWidth: 280, maxWidth: 340, textAlign: 'center' }}>
      <div style={{ marginBottom: 10, fontWeight: 600, color: '#222' }}>Question {current + 1} / {questions.length}</div>
      <div style={{ height: 8, background: '#e5e7eb', borderRadius: 6, marginBottom: 18, overflow: 'hidden' }}>
        <div style={{ width: `${100 - (timer / timeLimit) * 100}%`, height: '100%', background: timer > 5 ? '#22c55e' : '#ef4444', transition: 'width 0.2s' }} />
      </div>
      <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 16 }}>{q.question}</div>
      {q.image && <img src={q.image} alt="question visual" style={{ maxWidth: '100%', marginBottom: 12, borderRadius: 8 }} />}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {q.options.map(opt => (
          <button
            key={opt}
            className={`gogig-card-btn${selected === opt ? (opt === q.correctAnswer ? ' correct' : ' wrong') : '-outline'}`}
            style={{ fontSize: 16, border: feedback && opt === q.correctAnswer && feedback === 'correct' ? '2px solid #22c55e' : feedback && selected === opt && feedback === 'wrong' ? '2px solid #ef4444' : undefined, background: selected === opt ? (opt === q.correctAnswer ? '#bbf7d0' : '#fecaca') : undefined, color: selected === opt ? '#222' : undefined, transition: 'all 0.2s' }}
            onClick={() => handleAnswer(opt)}
            disabled={selected !== null}
          >
            {opt}
            {feedback && selected === opt && feedback === 'correct' && <span style={{ marginLeft: 8, color: '#22c55e', fontWeight: 700 }}>✅</span>}
            {feedback && selected === opt && feedback === 'wrong' && <span style={{ marginLeft: 8, color: '#ef4444', fontWeight: 700 }}>❌</span>}
          </button>
        ))}
      </div>
      <div style={{ marginTop: 18, color: '#888', fontSize: 15 }}>Time left: {timer}s</div>
    </div>
  );
}

export default SafetyGearQuiz; 